import { render, staticRenderFns } from "./onLineNotice.vue?vue&type=template&id=d9e5b45c&scoped=true"
import script from "./onLineNotice.vue?vue&type=script&lang=js"
export * from "./onLineNotice.vue?vue&type=script&lang=js"
import style0 from "./onLineNotice.vue?vue&type=style&index=0&id=d9e5b45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e5b45c",
  null
  
)

export default component.exports